/* Winkelwagen-suggesties: een product met één variant direct toevoegen (WOO-658).
   Het quick-add venster opent achter de cart drawer, dus daar zag je niets gebeuren.
   Na het toevoegen ververst de drawer zich via het bestaande event cart-drawer:refresh. */
(() => {
  if (window.cartCrossSellReady) return;
  window.cartCrossSellReady = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-add-variant]');
    if (!button || button.disabled) return;
    event.preventDefault();

    button.disabled = true;
    button.classList.add('is-loading');
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.cartAddVariant), quantity: 1 }] }),
      });
      if (!response.ok) throw new Error(`cart/add ${response.status}`);
      document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  });
})();
